/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useRef } from "react";

export default function useEvent<Args extends any[], R>(handler: (...args: Args) => R): typeof handler {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  return useCallback((...args: Args): R => {
    // In a real implementation, this would throw if called during render
    const fn = handlerRef.current;
    return fn!(...args);
  }, []);
}
